import React from 'react';
import { DishAssignmentState } from './dishAssignmentState/DishAssignmentState';
import { DishSection } from './components/DishSection/DishSection';
import { SubcategoriesSection } from './components/SubcategoriesSection/SubcategoriesSection';
import { ModalWindows } from './components/ModalWindows/ModalWindows';
import { AdditionalRestaurantsModal } from './components/AdditionalRestaurantsModal/AdditionalRestaurantsModal';
import { CreateSubcategoryModalPage } from './components/CreateSubcategoryModal/CreateSubcategoryModalPage';
import style from './index.module.scss';

export const DishAssignmentPageV2: React.FC = () => {
	return (
		<DishAssignmentState>
			<div className={style.container}>
				<DishSection />
				<SubcategoriesSection />
			</div>
			<ModalWindows />
			<AdditionalRestaurantsModal />
			<CreateSubcategoryModalPage />
		</DishAssignmentState>
	);
};
